import 'bootstrap/dist/js/bootstrap.js';
import { Carousel, Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import contents from './content.json';
export default function Leadership(){
    const { t } = useTranslation();
    return(
        <article>
          <section class="what-we-do leadership">
            <Container>
              <Row>
                <Col>
                  <div class="section-highlight">{t('home.leadership.section_title')}</div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div class="section-title">
                      <h4>{t('home.leadership.title')}</h4>
                  </div>
                </Col>
              </Row>
              <div className='content-wrapper'>
                <Row>
                  <Col>
                    <Carousel id="carouselLeadership" interval={2500}>
                      {contents.leadership.map((item, i)=>{
                        return(
                          <Carousel.Item>
                            <Row>
                              <Col md={12}>
                                <Row>
                                  <Col md={4}>
                                    <div class={`image-placeholder ${item.id}`}></div>
                                  </Col>
                                  <Col md={8}>
                                    <div class="content-wrapper align-centre">
                                        <div class="title">{item.name}</div>
                                        <div class="sub-title">{item.designation}</div>
                                        <div class="description">{t(`home.leadership.${item.id}.bio`)}</div>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Carousel.Item>
                        )
                      })}
                    </Carousel>
                  </Col>
                </Row>
              </div>
            </Container>
          </section>
        </article>
    )
}